import { getEnv } from '../config/env';

// This hook can be used in any component / hooks
export const useEnv = () => {
    const env = getEnv();
    return env;
};
